module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/profile/user-uploads/user-08.jpg";